import React from 'react';
import PropTypes from 'prop-types';
import {Field} from 'redux-form';

import Form from '@appComponents/ReduxFormControls';
import {getBookingStatusForOfferings, getBookingStatusForOfferingsDefaultValues} from '@utils/booking';

export const BookingStatusFilter = ({
    loading = false,
    filters,
    restoreFilterValues,
}) => (
    <Field
        component={Form.ReduxSelect}
        name='bookingStatus'
        disabled={loading}
        loading={loading}
        multiple
        options={getBookingStatusForOfferings()}
        placeholder='Booking status'
        setValue={restoreFilterValues(filters, 'bookingStatus', getBookingStatusForOfferingsDefaultValues())}
        selection
    />
);

BookingStatusFilter.propTypes = {
    loading: PropTypes.bool,
    filters: PropTypes.object.isRequired,
    restoreFilterValues: PropTypes.func.isRequired,
};
